
export const menuList = [
  /**
   * Dashboard Module Components
   */

  {
    id: 1,
    name: 'Stitching',
    icon: '/assets/images/stitching2.png',
    role: ['Explorations_View', 'Explorations_Add', 'Explorations_Edit', 'Explorations_Delete'],
    url: ['/explorations'],
    subMenu: []
  },
  {
    id: 2,
    name: 'GDV Optimizer',
    icon: '../../assets/images/gdv.svg',
    role: ['Projects_View', 'Projects_Add', 'Projects_Edit', 'Projects_Delete'],
    url: ['/project'],
    subMenu: []
  },
  // {
  //   id: 3,
  //   name: 'Projects',
  //   icon: '/assets/images/map-search1.png',
  //   role: ['Projects_View', 'Projects_Add', 'Projects_Edit', 'Projects_Delete'],
  //   url: ['/project'],
  //   subMenu: []
  // },
  {
    id: 4,
    name: 'Dashboard',
    icon: '/assets/images/DashboardIcon.svg',
    role: ['Dashboard_View', 'View_Dashboard_Inventory', 'View_Dashboard_Sale', 'View_Dashboard_Acquisition', 'View_Acquisition_Map'],
    url: [],
    subMenu: [
      // {
      //   id: 1,
      //   name: 'Acquisition Map',
      //   url: ['/dashboard/acquisition-map'],
      //   role: ['View_Acquisition_Map']
      // },
      {
        id: 1,
        name: 'Aquisition',
        url: ['/dashboard/acquisition-dashboard'],
        role: ['View_Dashboard_Acquisition']
      },
      {
        id: 2,
        name: 'Artist',
        url: ['/dashboard/inventory-dashboard'],
        role: ['View_Dashboard_Inventory']
      },
      {
        id: 3,
        name: 'Sales',
        url: ['/dashboard/sales-dashboard'],
        role: ['View_Dashboard_Sale']
      },
      {
        id: 3,
        name: 'Live',
        url: ['/dashboard/live-dashboard'],
        role: ['View_Dashboard_Acquisition']
      },
      // {
      //   id: 5,
      //   name: 'Documents',
      //   url: ['/document/acquisition-document-upload'],
      //   role: ['Acquisition_Document_Upload']
      // }
    ]
  },
  /**
   * Acquisition Module Components
   */
  {
    id: 6,
    name: 'Acquisition',
    icon: '../../assets/images/AcquisitionIcon.svg',
    role: ['View_Farmer', 'View_Khata', 'View_Khasra'],
    url: [],
    subMenu: [{
      id: 1,
      name: 'Farmer',
      url: ['/acquisition/farmer'],
      role: ['View_Farmer', 'Add_Farmer', 'Edit_Farmer'],
      source: 'farmer'
    },
    {
      id: 2,
      name: 'Khata',
      url: ['/acquisition/khata'],
      role: ['View_Khata', 'Add_Khata', 'Edit_Khata']
    },
    {
      id: 3,
      name: 'Khasra',
      url: ['/acquisition/khasra'],
      role: ['View_Khasra', 'Add_Khasra', 'Edit_Khasra']
    }
    ]
  },
  /**
   * CRM Module Components
   */
  // {
  //   id: 5,
  //   name: 'CRM',
  //   icon: '../../assets/images/CRMicon.svg',
  //   role: ['Unit_Category_Read', 'Unit_Description_Read'],
  //   url: [],
  //   subMenu: [{
  //     id: 1,
  //     name: 'Leads',
  //     url: ['/crm/leads'],
  //     role: ['Unit_Category_Read'],
  //   },
  //   ]
  // },
  /**
   * Legal Module Components
   */
  {
    id: 1,
    name: 'Legal',
    icon: '/assets/images/legal-icon.png',
    role: ['View_Legal_Rera', 'View_Rera_Form', 'View_Rera_Agent', 'View_Rera_Promoter'],
    url: [],
    subMenu: [{
      id: 1,
      name: 'Rera',
      role: ['View_Legal_Rera', 'View_Rera_Form', 'View_Rera_Agent', 'View_Rera_Promoter'],
      url: [],
      subMenu: [{
        id: 1,
        name: 'MAP',
        url: ['/legal/rera-map'],
        role: ['View_Legal_Rera'],
      },
      {
        id: 2,
        name: 'Form',
        url: [],
        role: ['View_Legal_Rera', 'View_Rera_Form', 'View_Rera_Promoter'],
        subMenu: [{
          id: 1,
          name: 'PRM',
          url: ['/legal/rera-promotors'],
          role: ['View_Rera_Form'],
        }, {
          id: 2,
          name: 'PRJ',
          url: [],
          role: ['View_Rera_Form'],
        }, {
          id: 3,
          name: 'Agent',
          url: [],
          role: ['View_Rera_Form'],
        }]
      }, {
        id: 2,
        name: 'Compliance',
        url: [],
        role: ['View_Rera_Promoter'],
        subMenu: [{
          id: 1,
          name: 'Quarterly',
          url: [],
          role: ['View_Rera_Promoter'],
        }, {
          id: 2,
          name: 'Handover',
          url: [],
          role: ['View_Rera_Promoter'],
        }]
      },
      {
        id: 3,
        name: 'Grievance',
        url: [],
        role: ['View_Rera_Promoter'],
      }],
    }]
  },
  /**
   * Sale Module Components
   */
  {
    /**
     * Sale Module Components
     */
    id: 1,
    name: 'Sales',
    icon: '../../assets/images/sale.svg',
    role: ['Booking_Read_Self', 'Booking_Read_Self_Team', 'Booking_Read_All',
      'Allotment_Read_Self', 'Allotment_Read_Self_Team', 'Allotment_Read_All',
      'Receipt_Read_Self', 'Receipt_Read_Self_Team', 'Receipt_Read_All',
      'Client_Read_Self', 'Client_Read_Self_Team', 'Client_Read_All'],
    url: [],
    subMenu: [{
      id: 1,
      name: "Clients",
      url: [],
      role: ['Booking_Read_Self', 'Booking_Read_Self_Team', 'Booking_Read_All',
        'Allotment_Read_Self', 'Allotment_Read_Self_Team', 'Allotment_Read_All',
        'Receipt_Read_Self', 'Receipt_Read_Self_Team', 'Receipt_Read_All',
        'Client_Read_Self', 'Client_Read_Self_Team', 'Client_Read_All'],
      subMenu: [
        //   {
        //   id: 1,
        //   name: "Map",
        //   role: [],
        //   url: []
        // },
        {
          id: 2,
          name: 'Bookings',
          url: [],
          role: ['Booking_Read_Self', 'Booking_Read_Self_Team', 'Booking_Read_All'],
          subMenu: [
            {
              id: 1,
              name: 'Active',
              url: ['/sales/booking'],
              role: ['Booking_Read_Self', 'Booking_Read_Self_Team', 'Booking_Read_All', 'Booking_Cancel_approval', 'Booking_Cancel']
            }, {
              id: 2,
              name: 'Pending Cancellations',
              url: ['/sales/booking/pending-cancellation'],
              role: ['Booking_Cancel_Approval',]
            },
            {
              id: 2,
              name: 'Cancelled',
              url: ['/sales/booking/cancelled'],
              role: ['Booking_Cancel',]
            }
          ]
        },
        {
          id: 3,
          name: 'Receipts',
          url: [],
          role: ['Receipt_Read_Self', 'Receipt_Read_Self_Team', 'Receipt_Read_All'],
          subMenu: [{
            id: 1,
            name: 'Receive',
            url: ['/sales/receipt'],
            role: ['Receipt_Read_Self', 'Receipt_Read_Self_Team', 'Receipt_Read_All', 'Receipt_Add']
          },
          {
            id: 1,
            name: 'Refund',
            url: ['/sales/receipt-refund'],
            role: ['Receipt_Refund_Read_Self', 'Receipt_Refund_Read_Self_Team', 'Receipt_Refund_Read_All', 'Receipt_Refund_Add']
          }]
        },
        {
          id: 4,
          name: 'Payment-Plan',
          url: ['/sales/paymentPlan'],
          role: ['Payment_Plan_Read']
        },
        {
          id: 5,
          name: 'Client',
          url: ['/sales/client'],
          role: ['Client_Read_Self', 'Client_Read_Self_Team', 'Client_Read_All']
        },
        {
          id: 6,
          name: 'Allotment',
          url: ['/sales/allotment'],
          role: ['Allotment_Read_Self', 'Allotment_Read_Self_Team', 'Allotment_Read_All']
        }
      ]
    }
    ]
  },

  /**
   * Accounts Module Components
   */
  {
    id: 3,
    name: 'Account',
    icon: '../../assets/images/accounticon.svg',
    role: ['Reconciliation_Read'],
    subMenu: [{
      id: 1,
      name: 'Reconcilation',
      url: ['/accounts/reconcilation'],
      role: ['Reconciliation_Read']
    },
    ]
  },

  /**
   * Manage Module Components
   */
  {
    id: 4,
    name: 'Manage',
    icon: '../../assets/images/manageIcon.svg',
    role: ['Unit_Category_Read', 'Unit_Description_Read', 'Sites_View'],
    url: [],
    subMenu: [{
      id: 1,
      name: 'Unit Description',
      url: ['/manage/unitDescription'],
      role: ['Unit_Description_Read']
    },
    {
      id: 2,
      name: 'Unit Category',
      url: ['/manage/unitCategory'],
      role: ['Unit_Category_Read']
    },
    {
      id: 3,
      name: 'Subscribers',
      url: ['/manage/subscribers'],
      role: ['Sites_View', 'Sites_Add', 'Sites_Edit']
    },
    ]
  },

  /**
   * Report Menu
   */
  {
    id: 3,
    name: 'Report',
    icon: '../../assets/images/Report 1.svg',
    role: ['Sale_Reports'],
    url: [],
    subMenu: [
      {
        id: 1,
        name: 'Sale',
        role: ['Sale_Reports'],
        url: [],
        subMenu: [
          {
            id: 1,
            name: 'By  Category',
            url: ['/sales/report/sale-unit-category'],
            role: ['Sale_Reports']
          }, {
            id: 2,
            name: 'By Associates',
            url: ['/sales/report/sale-agent-wise'],
            role: ['Sale_Reports']
          },
          {
            id: 3,
            name: 'By Client',
            url: [],
            role: ['Sale_Reports'],
            subMenu: [{
              id: 1,
              name: 'List',
              url: ['/sales/report/sale-client-wise'],
              role: ['Sale_Reports']
            },
            {
              id: 2,
              name: 'Map',
              url: ['/sales/report/sale-client-wise-map'],
              role: ['Sale_Reports']
            }]
          },
          {
            id: 4,
            name: 'By Ageing',
            url: ['/sales/report/sale-ageing-wise'],
            role: ['Sale_Reports']
          }, {
            id: 5,
            name: 'Market Outstanding By Ageing - Associate',
            url: ['/sales/report/outstanding-ageing-agent-wise'],
            role: ['Sale_Reports']
          }, {
            id: 6,
            name: 'Market Outstanding By Ageing - Client',
            url: ['/sales/report/outstanding-ageing-client-wise'],
            role: ['Sale_Reports']
          }
        ]
      }
    ]
  },
  /**
    * Documanp Module Components
    */
  {
    id: 6,
    name: 'Documap',
    icon: '/assets/images/legal-icon.png',
    role: ['View_Documap'],
    url: ['/legal/documap'],
    subMenu: []
  },
]